export const environment = {
  production: true,
  apiurl: "https://quest-api.stemwerkz.org/",
  apikey: "ndmc4acd43956e895b4de8aa7ec742edd3c",
  secretkey: "ndmc4acd43956e895b4de8aa7ec742edd3c",
  dashboardUrl: "https://student.stemwerkz.org/"
};
